<nz-spin [nzSpinning]="loading">
  <div class="wmsm-box">
    <div class="条件区">
      <app-wmsm-Rtconditions [show]="true" [ShowVendor]="true" [ShowRNO]="true" [ShowPONO]="false" [ShowPANo]="false"
        [ShowBillingStatus]="false" [ShowTime]="false" [QueryFromRT]="onQueryClick()"
        (listenForm)="getFormValue($event)"></app-wmsm-Rtconditions>
    </div>
    <div class="信息区" style="float: right"></div>
    <div class="查询区">
      <!-- <div class="查询条件">
        <form nz-form [formGroup]="validateForm">

          <div nz-row>
            <div nz-col nzSpan="8">
              <nz-form-item>
                <nz-form-label nzSpan="8">
                  <div class="width-100-percent label-font">{{ "StatementNo" | translate}}
                  </div>
                </nz-form-label>
                <nz-form-control nzSpan="16">
                  <input nz-input formControlName="StatementNo" />
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="5"  class="width-100-percent" style="left: 28px">
              <button nz-button class="default-button" nzType="primary" (click)="onSearch()">{{ "Query" | translate}}</button>
            </div>
          </div>
    </form>
      </div> -->
    </div>
    <nz-card>
      <div>
        <strong class="margin-left-8 result">{{ "Results" | translate}}({{nzTotal}})</strong>
      </div>
      <div class="表格">
        <nz-table #colSpanTable [nzData]="listOfData" style="margin-bottom: 10px" nzSize="middle" nzShowSizeChanger
          [nzOuterBordered]="true" [nzFrontPagination]="false" [nzShowPagination]='false' [nzPageSize]='pageSize'
          [nzPageIndex]='pageIndex' [nzScroll]="{ y: '600px',x:'2000px' }">
          <thead>
            <tr>
              <th scope="col" nzWidth="100px">{{ "WhetherInvoice" | translate}}</th>
              <th scope="col" nzWidth="100px">{{ "table.CompanyName" | translate}}</th>
              <th scope="col" nzWidth="150px">{{ "table.Buyer" | translate}}</th>
              <!-- <th scope="col" nzWidth="110px">{{ "Statement Month" | translate}}</th> -->
              <th scope="col" nzWidth="150px">{{ "StatementDate" | translate}}</th>
              <th scope="col" nzWidth="160px" [nzSortFn]="true" (nzSortOrderChange)="sortChange($event)">{{
                "StatementNo" | translate}}</th>
              <th scope="col" nzWidth="110px">{{ "table.Currency" | translate}}</th>
              <th scope="col" nzWidth="110px">{{ "StatementAmount" | translate}}</th>
              <th scope="col" nzWidth="150px">{{ "VendorCode" | translate}}</th>
              <th scope="col" nzWidth="150px">{{ "VendorName" | translate}}</th>
              <th scope="col" nzWidth="150px">{{ "SupplierWindow" | translate}}</th>
              <th scope="col" nzWidth="150px">{{ "AbnormalType" | translate}}</th>
              <th scope="col" nzWidth="150px">{{ "AbnormalMsg" | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of colSpanTable.data;let i=index">
              <td>{{data.isExistInvoice}}</td>
              <td>{{data.company}}</td>
              <td>{{data.buyerName}}</td>
              <!-- <td >{{data.acMonth}}</td> -->
              <td>{{data.acDate}}</td>
              <td>
                <span class="linkLabel" *ngIf="data.autoPaNo==null || data.autoPaNo==''"
                  (click)="RnoOnClick(data.rNo, data.currency, data.vendorCode, data.company)" style="text-decoration:underline;color:blue">
                  {{data.rNo}}
                </span>
                <span *ngIf="data.autoPaNo && data.flag=='F'">
                  {{data.rNo}}
                </span>
              </td>
              <td>{{data.currency}}</td>
              <td>{{data.rtAmount}}</td>
              <td>{{data.vendorCode}}</td>
              <td>{{data.vendorName}}</td>
              <td>{{data.vc}}</td>
              <td>{{data.abnormalType}}</td>
              <td>{{data.abnormalMsg}}</td>
            </tr>
          </tbody>
        </nz-table>
        <nz-pagination style="float:right;" [(nzPageIndex)]="pageIndex" [nzTotal]="nzTotal" [nzSize]="'small'"
          nzShowSizeChanger [nzPageSizeOptions]="[10, 20, 50,100]" [nzPageSize]='pageSize'
          (nzPageSizeChange)="nzPageSizeChange($event)" (nzPageIndexChange)="nzPageIndexChange($event)"></nz-pagination>
        <ng-template #renderItemTemplate let-type let-page="page">

          <a *ngIf="type === 'page'">{{ page }}</a>
          <a *ngIf="type === 'prev'" [style.color]="'black'">&#60;</a>
          <a *ngIf="type === 'next'" [style.color]="'black'">&#62;</a>
        </ng-template>
      </div>
    </nz-card>
  </div>
</nz-spin>
